import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { LetterOnBoard } from '@schoolbelle/api/letter-to-board';
import { GroupService } from '@schoolbelle/api/group';

@Component({
  selector: 'app-letter-content',
  templateUrl: './letter-content.component.html',
  styleUrls: ['./letter-content.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class LetterContentComponent implements OnInit {
  @Input() item :LetterOnBoard;
  @Input() content:string|{[lang:string]:string};
  @Input() lang:string;
  @Input() query:string;
  restricted:boolean = false;
  constructor(
    private group:GroupService,
  ) { }
  ngOnInit() {
    this.restricted = this.item && typeof this.item.scopes === 'string' && this.item.scopes.split(',').find(scope=>scope.match(/studentparent_(?!all)|faculty_(?!all)/) ? true : false) ? true : false;
  }

  checkPermission (scope:string):boolean {
    return this.group.checkPermission(scope);
  }
  get uid () {
    return this.group.currentGroup && this.group.currentGroup.uid || null;
  }
}
